const Download = () => {
  window.location.href = "https://www.instagram.com/sprosi.link/";
  return <div></div>;
};

export default Download;
